// extracted by mini-css-extract-plugin
export default {"tab":"MySurveys_tab__ShcgI","button":"MySurveys_button__renrt","buttonActive":"MySurveys_buttonActive__gO6-x"};